/*
  ============================================================
  PHOTOGRAPHY PREMIUM
  Theme configuration
  ============================================================
*/

export const themeConfig = {
  defaultTheme: "ivory",

  themes: {
    ivory: {
      id: "ivory",

      label: {
        fi: "Vaalea",
        en: "Ivory",
      },

      /*
        Toggle käyttää tätä visuaalisena merkkinä.
      */
      symbol: "light",
    },

    noir: {
      id: "noir",

      label: {
        fi: "Tumma",
        en: "Noir",
      },

      symbol: "dark",
    },
  },

  switcher: {
    /*
      icon-pill
      labels
    */
    variant: "icon-pill",
  },

  storageKey: "photography_premium_theme",
};

export default themeConfig;
